import React, { useState } from 'react'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { FormikTextField } from '../../CommonComponents/FormField'
import Footer from '../../Component/Footer'
import withRouter from '../../withRouter'
import MasterService from '../MasterService'
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";


const NewPrefixType = () => {
  const naviagte = useNavigate()
  const [prefixtype, setPrefixType] = useState("")
  const [defaultprefix, setDefaultprefix] = useState("")

  const onSubmit = () => {
    let data = {
      prefixtype: prefixtype,
      prefix: defaultprefix,
    }
    MasterService.AddPrefixType(data).then(() => {
      naviagte(-1)
    })
  }

  const validate = ()=>{
    let errors = {}

    if(!prefixtype){
      errors.prefixtype = "Please Enter Prefix Type"
    }
    if(!defaultprefix){
      errors.defaultprefix = "Please Enter Default Prefix"
    }

    return errors
  } 
  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
      <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/masters"},{name:"Prefix Types",path:"/prefixtypes"},{name:"New Prefix Type",path:null}]}/>
          </div>
            <div className="UI-form-card">
            <Formik
              initialValues={{}}
              validate={validate}
              onSubmit={onSubmit}
            >
              {({ errors }) => (
                <Form>
                  <div className="form-row">
                    <fieldset className='col-md-3'>
                      <TextfieldComponent
                        className="form-control"
                        type="text"
                        name="prefixtype"
                        label="Prefix Type"
                        value={prefixtype}
                        onChange={(e) =>
                          setPrefixType(e.target.value)
                        }
                        error={errors?.prefixtype}
                        required
                      />
                    </fieldset>
                    <fieldset className='col-md-3'>
                      <TextfieldComponent
                        className="form-control"
                        type="text"
                        name="defaultprefix"
                        label="Default prefix"
                        value={defaultprefix}
                        onChange={(e) =>
                          setDefaultprefix(e.target.value)
                        }
                        error={errors?.defaultprefix}
                        required
                      />
                    </fieldset>
                  </div>
                  <fieldset className="col-md-12 tw-mt-3">
                    <button
                      className="UI-btn UI-btn-primary tw-mr-1"
                      type="submit"
                    >
                      Save
                    </button>
                    <Link
                      as="button"
                      className="UI-btn UI-btn-outline"
                      to={{ pathname: "/prefixtypes" }}
                    >Cancel
                    </Link>
                  </fieldset>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default withRouter(NewPrefixType)